import { annImages } from "../../../../../game/helpers/annInstaImages";
import { TimageINT } from "../../../../store/slices/gameObjectSlice";
import { parseRequire } from "../../../../utils/parseImageUrl";
import { extras, images } from "../../../functions";
import { TGallery } from "./Gallery";



export const galleryScenesList: { [key: string]: TGallery; } = {

    ...createGalleryItem({
        text: "Swipe right",
        imageKey: extras.gallery1.key,
        conditionScene: "",
        imageCondition: images.v1_JoeShowingPics.JoeyShowingPhone6,
        page: 0,
        tags: ["SOLO"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Yes, show me",
        imageKey: images.v2.BarChris3.key,
        conditionScene: "eveningBarAlone",
        page: 0,
        tags: ["BLOWJOB", "NTR"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Panties off",
        imageKey: images.v2.VanessaHomeBlackRed3.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Turn around",
        imageKey: images.v2.VanessaHomeTeaseButt.key,
        conditionScene: "beachVanessaAlone5",
        page: 0,
        tags: ["PINUP"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Cleanup",
        imageKey: images.v2_5.pre_VanessaJoeLivingRoomCumTease.key,
        conditionScene: "TODWatchingVanessaJoe",
        page: 0,
        tags: ["NTR", "BLOWJOB"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Kissing game",
        imageKey: images.v2_5.TODAnnVanessaKiss2.key,
        conditionScene: "TODAnnJoe1KissVanessa",
        page: 0,
        tags: ["FOREPLAY"],
        chars: ["ann", "vanessa"],
    }),
    ...createGalleryItem({
        text: "Show boobs",
        imageKey: images.v2_5.TODSelfVanessa4.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Show pussy",
        imageKey: images.v2_5.TODSelfVanessa5.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Deeper!",
        imageKey: images.v3.AnnRoom17.key,
        conditionScene: "AnnAfterTODLoveBJ_Question2",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Just suck it",
        imageKey: images.v3.Anim_VanessaCoffeeHJ.key,
        conditionScene: "VanessaCoffee5Blackmail_Customer_Question",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Give a napkin",
        imageKey: images.v4.AfterBarAnnRoom19.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Vanessa's pee break",
        imageKey: images.v4.Anim_BarVanessaToilet.key,
        conditionScene: "ClubEventJoeInsideDontTurnAround2",
        page: 0,
        tags: ["BLOWJOB", "NTR"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "How's the weather?",
        imageKey: images.v4.Anim_V4VanessaAlleyBJ.key,
        conditionScene: "ClubEventWithoutJoeInsideVanessaBJStay2",
        page: 0,
        tags: ["BLOWJOB", "NTR"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Drank too much",
        imageKey: images.v4.Anim_SexTapeCum.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Drank too much",
        imageKey: images.v4.Anim_SexTapeCum.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Body shots",
        imageKey: images.v4.VanessaAfterParty6.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Sneak peek",
        imageKey: images.v4.VanessaAfterPartyHome10.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Busted!",
        imageKey: images.v5.AnnArrived_11.key,
        conditionScene: "",
        page: 0,
        tags: ["FOREPLAY"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Cleanup",
        imageKey: images.v5.AnnRoomEvening_26_2.key,
        conditionScene: "AnnRoomEvening_5_Fuck_Face_Clean",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Lost the phone",
        imageKey: images.v5.VanessaRoom_30.key,
        conditionScene: "V5VanessaHouseMorningVanessasFather6ConversationAfter",
        page: 0,
        tags: ["PINUP"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Merry Christmas!",
        imageKey: images.v5.ChrisMerry_28.key,
        conditionScene: "V5ChrisRandomGirl_ReturnToMerry_Question_Ass",
        page: 0,
        tags: ["ANAL"],
        chars: ["merry"],
    }),
    ...createGalleryItem({
        text: "Sharing is caring",
        imageKey: (images.v5.AnnVanessaRoom_20.partials.AnnVanessaRoom_outfit_0 as TimageINT).key!,
        conditionScene: "V5AnnSexEveningVanessaJoined4",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ["ann", "vanessa"],
    }),

    ...createGalleryItem({
        text: "Trying out",
        imageKey: images.v6.EmilyShopping_25.key,
        conditionScene: "V6AfterEmilyShoppingTryingLingerieMario_Question_CheckYourself",
        page: 0,
        tags: ["PINUP"],
        chars: ["emily"],
    }),
    ...createGalleryItem({
        text: "No locks",
        imageKey: images.v6.EmilyShopping_30.key,
        conditionScene: "V6AfterEmilyShoppingTryingLingerieAmber_Question_Excuse",
        page: 0,
        tags: ["PINUP"],
        chars: ["amber"],
    }),
    ...createGalleryItem({
        text: "That's private",
        imageKey: extras.EmilyGallery.key,
        imageCondition: images.v6.EmilyPhone_2,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ["emily"],
    }),
    ...createGalleryItem({
        text: "Jenny's PJ",
        imageKey: images.v6.JennyPhone_2.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ["jenny"],
    }),
    ...createGalleryItem({
        text: "Surprise!",
        imageKey: images.v6.Underpass_42.key,
        conditionScene: "",
        page: 0,
        tags: ["HANDJOB"],
        chars: ["vanessa", "ann"],
    }),
    ...createGalleryItem({
        text: "Ear plug",
        imageKey: images.v6.VanessaCustomerMeeting_17.key,
        conditionScene: "",
        page: 0,
        tags: ["NTR"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Double trouble",
        imageKey: images.v6.VanessaHouse_19.key,
        conditionScene: "V6VanessaHomeRoomJoeRival_Listen_Question_OpenPants",
        page: 0,
        tags: ["NTR", "BLOWJOB"],
        chars: ["ann", "vanessa"],
    }),
    ...createGalleryItem({
        text: "Stopping it",
        imageKey: images.v6.VanessaHouse_27.key,
        conditionScene: "V6VanessaHomeRoom_2_AnnChrisStory_Question_StopIt",
        page: 0,
        tags: ["NTR"],
        chars: [],
    }),
    ...createGalleryItem({
        text: "Joey's forgiveness",
        imageKey: images.v6.VanessaHouse_19.key,
        conditionScene: "V6VanessaHomeRoomJoeRival_Listen_Question_OpenPants",
        page: 0,
        tags: ["NTR"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Vanessa's chair",
        imageKey: images.v6.VanessasLivingRoom_5.key,
        conditionScene: "V6VanessaHomeRoom_2_Question_DoIt_2_1",
        page: 0,
        tags: ["VAGINAL"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Vanessa's siblings",
        imageKey: images.v6.VanessasLivingRoom_16.key,
        conditionScene: "V6VanessaHomeRoom_2_Parents",
        page: 0,
        tags: ["VAGINAL"],
        chars: ["ramona"],
    }),
    ...createGalleryItem({
        text: "Memories",
        imageKey: images.v6.AnnChrisMemory_5.key,
        conditionScene: "V6VanessaHomeRoom_2_AnnChrisStory_Question_Listen",
        page: 0,
        tags: ["BLOWJOB", "NTR"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "It's too small",
        imageKey: images.v6.VanessaShopping_24.key,
        conditionScene: "V6VanessaShopping_Question_TryOn",
        page: 0,
        tags: ["PINUP"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Say cheese!",
        imageKey: images.v7.AlexMovingRoom_8.key,
        conditionScene: "V6VanessaShopping_Question_TryOn",
        page: 0,
        tags: ["PINUP"],
        chars: ["alex"],
    }),
    ...createGalleryItem({
        text: "Vanessa passing the time",
        imageKey: images.v7.AmberMario_10.key,
        conditionScene: "V7ReturningOutfit_LivingRoomEarlyMarioVanessaFuck",
        page: 0,
        tags: ["ANAL", "NTR"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Story time",
        imageKey: images.v7.AmberMario_34.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "What's your name?",
        imageKey: images.v7.AmberSex_24.key,
        conditionScene: "V7ReturningOutfit_McAmberInside_2",
        page: 0,
        tags: ["PINUP"],
        chars: ["amber"],
    }),
    ...createGalleryItem({
        text: "Car wash",
        imageKey: images.v7.EmilyCarWash_8.key,
        conditionScene: "V7EmilyCarWash",
        page: 0,
        tags: ["PINUP"],
        chars: ["emily"],
    }),
    ...createGalleryItem({
        text: "Shower time",
        imageKey: images.v7.EmilyShower_5.key,
        conditionScene: "V7EmilyShower",
        page: 0,
        tags: ["PINUP"],
        chars: ["emily"],
    }),
    ...createGalleryItem({
        text: "Nice view",
        imageKey: images.v7.JennyDate_34.key,
        conditionScene: "V7JennyDate11_Question_Kiss_Question_Further",
        page: 0,
        tags: ["PINUP"],
        chars: ["jenny"],
    }),
    ...createGalleryItem({
        text: "Nice view",
        imageKey: images.v7.JennyDate_34.key,
        conditionScene: "V7JennyDate11_Question_Kiss_Question_Further",
        page: 0,
        tags: ["PINUP"],
        chars: ["jenny"],
    }),
    ...createGalleryItem({
        text: "You got the job",
        imageKey: images.v7.AnnMCDirectorHotel_10.key,
        conditionScene: "V7AnnDirectorHotel2_Question_Agree",
        page: 0,
        tags: ["PINUP", "NTR"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Wear it now",
        imageKey: images.v7.V7AnnHouseHate_13.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP", "NTR"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Probing",
        imageKey: images.v7.V7AnnMCRoom_16.key,
        conditionScene: "V7AnnAtMCRoom2_Question_Fuck_Question_Finger",
        page: 0,
        tags: ["VAGINAL", "ANAL"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Watching the movie",
        imageKey: images.v7.V7AnnChrisMovie_15.key,
        conditionScene: "V7AnnChrisMCMovies3_McShare_Question_Touch_Question_Continue",
        page: 0,
        tags: ["FOREPLAY", "NTR"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Chris is watching the movie",
        imageKey: images.v7.V7AnnChrisMovie_12.key,
        conditionScene: "V7AnnChrisMCMovies3_ChrisShare2",
        page: 0,
        tags: ["FOREPLAY", "NTR"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Basketball break",
        imageKey: annImages.Ann17.key,
        conditionScene: "V7AnnMCCityPhotoShoot2Players_Question_Invite_Question_Another",
        page: 0,
        tags: ["PINUP", "NTR"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Photo shoot ending",
        imageKey: images.v7.V7AnnOutside_50.key,
        conditionScene: "V7AnnMCAlleyPhotoShoot5_Question_Fuck",
        page: 0,
        tags: ["VAGINAL", "NTR"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Practicing",
        imageKey: images.v7.Anim_AnnMCPreAudition.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Practicing with Chris",
        imageKey: images.v7.Anim_AnnMCPreAuditionCum.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB", "NTR"],
        chars: ["ann"],
    }),
    ...createGalleryItem({
        text: "Gotta get the job",
        imageKey: images.v7.V7VanessaCoffeeNight_41.key,
        conditionScene: "",
        page: 0,
        tags: ["FOREPLAY", "NTR"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Watching the Sex tape",
        imageKey: images.v7.SexTapeNoMC_6.key,
        conditionScene: "",
        page: 0,
        tags: ["VAGINAL", "NTR"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Eating breakfast",
        imageKey: images.v7.V7VanessaMCNudeHome_15.key,
        conditionScene: "",
        page: 0,
        tags: ["FOREPLAY"],
        chars: ["vanessa"],
    }),
    ...createGalleryItem({
        text: "Enough talking",
        imageKey: images.v8.V8AlexAnnHome_40.key,
        conditionScene: "V8AnnAlexHome_2",
        page: 0,
        tags: ["PINUP"],
        chars: ["alex", 'ann'],
    }),
    ...createGalleryItem({
        text: "Short skirt",
        imageKey: images.v8.V8PickingUpAnnCorrupted_6.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Ferris Wheel fun",
        imageKey: images.v8.Anim_AnnFerrisWheelBJ.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Flashing",
        imageKey: images.v8.V8AnnDateCorrupted_92.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP", "NTR"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Skyping",
        imageKey: images.v8.AnnDormNight_30.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Skyping",
        imageKey: images.v8.AnnDormNight_30.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Break-up sex",
        imageKey: images.v8.Anim_EmilyExSex.key,
        conditionScene: "V8EmilyAndEx_KeepWatching",
        page: 0,
        tags: ["VAGINAL", "NTR"],
        chars: ['emily'],
    }),
    ...createGalleryItem({
        text: "Break-up sex",
        imageKey: images.v8.Anim_EmilyExSex.key,
        conditionScene: "V8EmilyAndEx_KeepWatching",
        page: 0,
        tags: ["VAGINAL", "NTR"],
        chars: ['emily'],
    }),
    // ...createGalleryItem({
    //     text: "I'm stuck!",
    //     imageKey: images.v8.V8EmilyMorning_12.key,
    //     conditionScene: "V8MorningEmilyKitchen",
    //     page: 0,
    //     tags: ["PINUP"],
    //     chars: ['emily'],
    // }),
    ...createGalleryItem({
        text: "Checking pulse",
        imageKey: images.v8.Anim_V8EmilyMCHandMoving.key,
        conditionScene: "V8EmilyAnnMovieNight_ExposeBreasts",
        page: 0,
        tags: ["FOREPLAY"],
        chars: ['emily'],
    }),
    ...createGalleryItem({
        text: "Surprise kiss",
        imageKey: images.v8.V8EmilyMovieNight_34.key,
        conditionScene: "",
        page: 0,
        tags: ["FOREPLAY"],
        chars: ['emily'],
    }),
    ...createGalleryItem({
        text: "Solo play",
        imageKey: images.v8.Anim_EmilyMasturbationFingers.key,
        conditionScene: "",
        page: 0,
        tags: ["FOREPLAY"],
        chars: ['emily'],
    }),

    ...createGalleryItem({
        text: "Vanessa's genes",
        imageKey: images.v8.V8MorningVanessaConv_17.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['ramona'],
    }),
    ...createGalleryItem({
        text: "Is that allowed?",
        imageKey: images.v8.VanessaDildo_1.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Smile for the camera",
        imageKey: images.v8.V8VanessaMCBeach_72.key,
        conditionScene: "V8VanessaMCBeach_FuckAngela",
        page: 0,
        tags: ["PINUP"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Go further",
        imageKey: images.v8.V8JennyDate_38.key,
        conditionScene: "",
        page: 0,
        tags: ["FOREPLAY"],
        chars: ['jenny'],
    }),
    ...createGalleryItem({
        text: "Joey can wait",
        imageKey: images.v8.V8MCJoeVanessa_141.key,
        conditionScene: "V8VanessaJoeMCThreesome_GrabVanessa_AfterChoices",
        page: 0,
        tags: ["VAGINAL", "PINUP"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Join the fun",
        imageKey: images.v8.Anim_V8MCJoeVanessaDPMCAnal.key,
        conditionScene: "V8VanessaJoeThreesome_JoinThem_JoeFirst",
        page: 0,
        tags: ["VAGINAL", "ANAL", "PINUP"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "I rather wait",
        imageKey: images.v8.V8MCJoeVanessa_124.key,
        conditionScene: "V8VanessaJoeThreesome_JustWatch_AcceptHandjob",
        page: 0,
        tags: ["PINUP", "NTR"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Fingering",
        imageKey: images.v8.Anim_V8VanessaMCNightFingering.key,
        conditionScene: "",
        page: 0,
        tags: ["FOREPLAY"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Working out",
        imageKey: images.v8.Anim_V8VanessaMCNightDoggyPhone.key,
        conditionScene: "",
        page: 0,
        tags: ["ANAL"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Good morning",
        imageKey: images.v8.Anim_V8VanessaMCNightLicking.key,
        conditionScene: "",
        page: 0,
        tags: ["FOREPLAY"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Helping a friend out",
        imageKey: images.v8.Anim_V8AnnChrisMCChrisAnalClose.key,
        conditionScene: "",
        page: 0,
        tags: ["ANAL", "NTR"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Ann's special night",
        imageKey: images.v8.Anim_V8AnnChrisMCDoggyChrisBJ.key,
        conditionScene: "",
        page: 0,
        tags: ["VAGINAL", "THREESOME", "NTR"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Ann's watching a movie",
        imageKey: images.v8.V8AnnChrisPics_13.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB", "NTR"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Chris offered to help",
        imageKey: images.v8.V8AnnChrisPics_19.key,
        conditionScene: "",
        page: 0,
        tags: ["ANAL", "NTR"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "It's too big!",
        imageKey: images.v8.V8AnnCorruptionAfterLibraryRoom_6.key,
        conditionScene: "",
        page: 0,
        tags: ["ANAL"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "She likes it rough",
        imageKey: images.v8.Anim_V8AnnCorruptionBeforeLibraryMiss.key,
        conditionScene: "",
        page: 0,
        tags: ["VAGINAL"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "That was fast",
        imageKey: images.v8.V8AnnCorruptionLibrary_26.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB", "NTR"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Quiet in the library",
        imageKey: images.v8.V8AnnCorruptionLibrary_38.key,
        conditionScene: "",
        page: 0,
        tags: ["PUSSYLICK"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Let's see what he'll do",
        imageKey: images.v8.V8AnnMCAlley_14.key,
        conditionScene: "",
        page: 0,
        tags: ["NTR", "FOREPLAY"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "She got closer!",
        imageKey: images.v8.V8EmilyRoomNightAfterKitchen_5.key,
        conditionScene: "",
        page: 0,
        tags: ["FOREPLAY"],
        chars: ['emily'],
    }),
    ...createGalleryItem({
        text: "You are here by choice",
        imageKey: images.v8.V8VanessaCustomerHotel_44.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "My PC got stuck",
        imageKey: images.v9.V9AnnDormCallIvy_11.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['ivy'],
    }),

    ...createGalleryItem({
        text: "Be wevy weby quiet",
        imageKey: images.v9.Anim_V9VanessaMCOutsideBusStorking.key,
        conditionScene: "",
        page: 0,
        tags: ["HANDJOB"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "This is my stop",
        imageKey: images.v9.V9VanessaMCOutsideBus_38.key,
        conditionScene: "",
        page: 0,
        tags: ["HANDJOB", "NTR"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Had to use the bathroom",
        imageKey: images.v9.V9BarToilet_17.key,
        conditionScene: "",
        page: 0,
        tags: ["VAGINAL"],
        chars: ['kim'],
    }),
    ...createGalleryItem({
        text: "Don't let it go soft",
        imageKey: images.v9.V9BarToilet_26.key,
        conditionScene: "",
        page: 0,
        tags: ["THREESOME", "BLOWJOB", "NTR"],
        chars: ['vanessa', "kim"],
    }),
    ...createGalleryItem({
        text: "Always here to support",
        imageKey: images.v9.Anim_V9VanessaChrisBehindBarLeaning.key,
        conditionScene: "",
        page: 0,
        tags: ["VAGINAL", "NTR"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "That's how she focuses",
        imageKey: (images.v9.V9VanessaMCBusNight_14.partials.V9VanessaMCBusNight_26 as any).key,
        conditionScene: "",
        page: 0,
        tags: ["PUSSYLICK", "NTR"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Let's just enjoy the ride",
        imageKey: images.v9.V9VanessaMCBusNight_15.key,
        conditionScene: "",
        page: 0,
        tags: [],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Two fingers",
        imageKey: images.v9.Anim_V9VanessaMCBusNightFingers.key,
        conditionScene: "",
        page: 0,
        tags: ["HANDJOB"],
        chars: ['vanessa'],
    }),
    ...createGalleryItem({
        text: "Quality time",
        imageKey: images.v9.Anim_V9EmilyMCMorningTogether.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['emily'],
    }),
    ...createGalleryItem({
        text: "Webcam show",
        imageKey: images.v9.V9AnnDormNightChris_48.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB", "VAGINAL", "NTR"],
        chars: ['alex'],
    }),
    ...createGalleryItem({
        text: "Pose for the camera",
        imageKey: images.v9.V9AlexDateAfter_35.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['alex'],
    }),
    ...createGalleryItem({
        text: "Friendly hug",
        imageKey: images.v9.V9EmilyMorningRoomDay3_16.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['emily'],
    }),

    ...createGalleryItem({
        text: "Show me your body",
        imageKey: images.v9.V9AnnCorNight_13.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Did she feel it?",
        imageKey: images.v9.V9EmilyNightSleepDay2_9.key,
        conditionScene: "",
        page: 0,
        tags: ["PINUP"],
        chars: ['emily'],
    }),

    ...createGalleryItem({
        text: "Road trip",
        imageKey: images.v9.V9AnnMCMotelDriving_4.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Pussy it is",
        imageKey: images.v9.V9AnnMCMotel_244.key,
        conditionScene: "",
        page: 0,
        tags: ["BLOWJOB", "NTR"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Sleeping like a rock",
        imageKey: (images.v9.V9AnnMCMotel_234.partials.V9AnnMCMotel_233 as any).key,
        conditionScene: "",
        page: 0,
        tags: ["ANAL", "NTR"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "She likes it rough",
        imageKey: (images.v9.V9AnnMCMotel_294.partials.V9AnnMCMotel_295 as TimageINT).key as string,
        conditionScene: "",
        page: 0,
        tags: ["VAGINAL"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Ass training",
        imageKey: images.v9.V9AnnMCMotel_154.key,
        conditionScene: "",
        page: 0,
        tags: ["ANAL"],
        chars: ['ann'],
    }),
    ...createGalleryItem({
        text: "Bullseye",
        imageKey: images.v9.V9AnnMCMotel_116.key,
        conditionScene: "",
        page: 0,
        tags: ["VAGINAL"],
        chars: ['ann'],
    }),

};

function createGalleryItem(data: Omit<TGallery, "seen" | "gameState">): { [key: string]: TGallery; } {
    return {
        [data.imageKey.toString()]: {
            ...data,
            seen: false

        }
    };
};
